import { render, staticRenderFns } from "./SectionHead.vue?vue&type=template&id=23b51583&scoped=true"
import script from "./SectionHead.vue?vue&type=script&lang=js"
export * from "./SectionHead.vue?vue&type=script&lang=js"
import style0 from "./SectionHead.vue?vue&type=style&index=0&id=23b51583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b51583",
  null
  
)

export default component.exports